/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_ValidationInputs */

const en_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter username and password`)
};

const fr_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir le nom d’utilisateur et le mot de passe`)
};

const de_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie Benutzernamen und Passwort ein.`)
};

const it_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci nome utente e password`)
};

const ru_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите имя пользователя и пароль.`)
};

const es_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca su nombre de usuario y contraseña`)
};

const zh_cn2_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入用户名和密码`)
};

const ja_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名とパスワードを入力してください`)
};

const hi_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया उपयोगकर्ता नाम और पासवर्ड दर्ज करें`)
};

const pt_pt2_work_order_publish_auth_validation = /** @type {(inputs: Work_Order_Publish_Auth_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira o nome de usuário e a senha.`)
};

/**
* | output |
* | --- |
* | "Please enter username and password" |
*
* @param {Work_Order_Publish_Auth_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_validation = /** @type {((inputs?: Work_Order_Publish_Auth_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_auth_validation(inputs)
	if (locale === "de") return de_work_order_publish_auth_validation(inputs)
	if (locale === "it") return it_work_order_publish_auth_validation(inputs)
	if (locale === "ru") return ru_work_order_publish_auth_validation(inputs)
	if (locale === "es") return es_work_order_publish_auth_validation(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_auth_validation(inputs)
	if (locale === "ja") return ja_work_order_publish_auth_validation(inputs)
	if (locale === "hi") return hi_work_order_publish_auth_validation(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_auth_validation(inputs)
	return en_work_order_publish_auth_validation(inputs)
});